import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Pipe({
  standalone: true,
  name: 'toFormControl'
})
export class ToFormControlPipe implements PipeTransform {
  transform(control: AbstractControl): UntypedFormControl {
    return control as UntypedFormControl;
  }
}
